import { Button, Space, Typography } from "antd";
import React from "react";
import styled from "styled-components";

import Spinner from "../../../../components/Spinner";
import intl from "../../../../utils/intl";
import FuelingProcessDetailBasicInfo from "../FuelingProcessDetailBasicInfo";
import FuelingProcessDetailEvents from "../FuelingProcessDetailEvents";
import messages from "./messages";
import FuelingProcessesDetailProps from "./props";

const Layout = styled.div`
  padding: 0 0 20px;
`;

const ProcessTableDetail: React.FC<FuelingProcessesDetailProps> = (
  props: FuelingProcessesDetailProps
) => {
  return (
    <>
      <Typography.Title level={4}>
        {intl.formatMessage(messages.detailsTitle)}
      </Typography.Title>
      {props.loading && <Spinner />}
      {props.fuelingProcess && (
        <>
          {props.fuelingProcess.details.isEditable && (
            <Layout>
              <Space>
                <Button
                  id="setReceiptBtn"
                  type="primary"
                  onClick={props.onSetReceipt}
                >
                  {intl.formatMessage(messages.setReceipt)}
                </Button>
                <Button
                  id="cancelProcessBtn"
                  type="primary"
                  danger
                  onClick={props.onCancelProcess}
                >
                  {intl.formatMessage(messages.cancelProcess)}
                </Button>
              </Space>
            </Layout>
          )}
          <Layout>
            <FuelingProcessDetailBasicInfo
              details={props.fuelingProcess.details}
            />
          </Layout>
          <Layout>
            <FuelingProcessDetailEvents events={props.fuelingProcess.events} />
          </Layout>
        </>
      )}
    </>
  );
};

export default ProcessTableDetail;
